import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Search } from "lucide-react";

export const SearchBar = ({ className = "", autoFocus = false, testId = "search-input" }) => {
  const [params] = useSearchParams();
  const [q, setQ] = useState(params.get("q") || "");
  const navigate = useNavigate();
  const submit = (e) => { e.preventDefault(); if (q.trim().length >= 2) navigate(`/search?q=${encodeURIComponent(q.trim())}`); };
  return (
    <form onSubmit={submit} className={`relative ${className}`} role="search" data-testid="search-form">
      <Search size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none" />
      <input value={q} onChange={(e) => setQ(e.target.value)} autoFocus={autoFocus} placeholder="Search episodes…" className="w-full h-10 rounded-full bg-white/5 border border-white/10 pl-10 pr-4 text-sm text-white placeholder:text-slate-500 outline-none focus:border-sky-400/60 focus:bg-white/10 transition-colors" data-testid={testId} />
    </form>
  );
};
